import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Col, Row} from "reactstrap";
import Answer from "./Answer";
import Target from "./Target";
import classnames from "classnames";
import ScalePoints from "container/Question/ScalePoints";
import Sortable from "react-sortablejs";
import {FormattedMessage} from "react-intl";

class DragDrop extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      highestAnswerHeight: 100
    };

    this.basketTarget = React.createRef();
    this.setHighestAnswerHeight = this.setHighestAnswerHeight.bind(this)
  }

  setHighestAnswerHeight(highestAnswerHeight) {
    this.setState({highestAnswerHeight})
  }

  render() {
    const {question, details} = this.props;

    return (
        <React.Fragment>
            <div className={"card-body answer-area"}>
          <Sortable
              className={classnames({
                "d-flex flex-wrap answers-container": true,
                "stack-container mr-5 ml-5": question.stackedAnswers
              })} style={{maxWidth: '100%'}}
              options={{
                group: {
                  name: 'numericMulti-answers-' + question.id,
                },
                animation: 100
              }}
          >
            {question.answers.filter(answer => details.filter(detail => detail.answer === answer.id).length === 0).map((answer) => {
              return <Answer
                  key={'aa' + answer.id}
                  details={details}
                  isHidden={!!details.find(detail => detail.answer === answer.id)}
                  detail={details.find(detail => detail.answer === answer.id)}
                  isActive={false}
                  answer={answer}
                  question={question}
                  setHighestAnswerHeight={this.setHighestAnswerHeight}
                  highestAnswerHeight={this.state.highestAnswerHeight}
                  setDragging={e => {
                    if (this.basketTarget.current) {
                      this.basketTarget.current.onDrag(e)
                    }
                  }}
              />
            })}
          </Sortable>
          <div className={"text-center sort-to-baskets mt-4 mb-5"}>
            <i className={"fa-solid fa-circle-caret-down mr-2"}/><span><FormattedMessage id={"question.dragAndDrop.moveToTarget"}/></span>
          </div>
          <Target
              setHighestAnswerHeight={this.setHighestAnswerHeight}
              question={question}
              answers={question.answers.filter(answer => details.filter(detail => detail.answer === answer.id).length > 0)}
              details={details}
              handleDrop={this.props.handleDrop}
              ref={this.basketTarget}
          />
          <ScalePoints scalePoints={question.scalePoints} />
            </div>
        </React.Fragment>
    );
  }
}

DragDrop.propTypes = {
  question: PropTypes.shape({
    answers: PropTypes.array.isRequired,
    stackedAnswers: PropTypes.bool.isRequired,
  }).isRequired,
  details: PropTypes.array.isRequired,
  handleDrop: PropTypes.func.isRequired,
};

export default DragDrop;